/* 布局 */
//前台
import Layout from "@views/layout";

const ordermanageRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "ordermanage",
            name: "ORDERMANAGE",
            meta: {
                title: "下单管理",
                sort: 1,
            },
            component: () => import("@views/business/ordermanage/index.vue"),
            redirect: {
                name: "ORDERMANAGE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "ORDERMANAGE_LIST",
                    meta: {
                        title: "下单管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/ordermanage/list.vue"),
                },
                                {
                    path: "add",
                    name: "ORDERMANAGE_ADD",
                    meta: {
                        title: "新增下单管理",
                        parentPath: '/business/ordermanage/list',
                        operate: true,
                    },
                    component: () => import("@views/business/ordermanage/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "ORDERMANAGE_EDIT",
                    meta: {
                        title: "编辑下单管理",
                        parentPath: '/business/ordermanage/list',
                        operate: true,
                    },
                    component: () => import("@views/business/ordermanage/form.vue"),
                },
                                        ],
    },


        ],
};

export default ordermanageRouter;
